import * as React from 'react';

import { Box, Checkbox, Paper } from '@mui/material';
import CustomPaginationActionsTable from '../../../components/TablePagination';
import PaginateDataModel from '../../../Models/PaginateDataModel';

interface CriticalChecksListProps {
  handlePagination: (data: any) => void;
  handleStatus: (data: any, type: string) => void;
  search?: any;
  recordList: any[];
  selectedRecords: any[];
  totalRecords: number;
  paginate: PaginateDataModel;
}
const CriticalChecksList: React.FC<CriticalChecksListProps> = ({
  handlePagination,
  handleStatus,
  recordList,
  selectedRecords,
  totalRecords,
  paginate,
}) => {
  const columns: any[] = [
    {
      field: 'id',
      headerName: 'Activity',
      renderCell: (value: any, row: any) => (
        <Box sx={{ display: 'flex', alignItems: 'anchor-center' }}>
          <Checkbox
            edge="start"
            checked={selectedRecords.includes(value)}
            tabIndex={-1}
            disableRipple
          />

          <Box sx={{ display: 'flex', alignItems: 'anchor-center' }}>
            <small>{row.activity}</small>
          </Box>
        </Box>
      ),
    },
    {
      field: 'inspectionPoint',
      headerName: 'Inspection Point',
    },
    {
      field: 'testMethod',
      headerName: 'Test Method',
    },
    {
      field: 'acceptanceCriteria',
      headerName: 'Acceptance Criteria',
    },
    {
      field: 'responsibleParty',
      headerName: 'Responsible Party',
    },
    {
      field: 'holdWitnessPoint',
      headerName: 'Hold Point (HP)/ Witness Point (WP)',
    },
  ];
  return (
    <Paper sx={{ width: '100%' }} className="mt-4">
      <CustomPaginationActionsTable
        rows={recordList}
        columns={columns}
        totalRecords={totalRecords}
        handlePagination={(data: any) => {
          handlePagination(data);
        }}
        handleRowClick={(row: any) => {
          console.log('row-clicked');
          //   navigate('/data-management/labour/' + row.id);
          //console.log(data);
        }}
        paginationModel={{
          page: paginate.offset,
          pageSize: paginate.limit,
        }}
        handleStatus={(data: any) => {
          handleStatus(data, 'labour');
        }}
      />
    </Paper>
  );
};
export default CriticalChecksList;
